<ng-container *ngIf="message">
  <!-- Toolbar -->
  <div class="updox-detail-toolbar">
    <h4 class="updox-detail-subject m0" title="{{ message.display_subject }}">
      {{ message.display_subject }}
    </h4>
    <div class="updox-detail-actions">

      <!-- Draft actions -->
      <ng-container *ngIf="isDraft">
        <button type="button" class="btn btn-primary mr-sm" (click)="editDraft.emit(message)">
          <i class="fa fa-pencil mr-sm"></i>Edit &amp; Send
        </button>
      </ng-container>

      <!-- Inbox / Sent actions -->
      <ng-container *ngIf="!isDraft">
        <button tooltip="Reply" type="button" class="btn btn-secondary btn-outline btn-sm mr" (click)="replyToMessage()">
          <i class="fa fa-reply"></i>
        </button>
        <button tooltip="Mark as unread" type="button" class="btn btn-tertiary btn-outline btn-sm mr"
                *ngIf="message.folder === 'inbox' && message.read"
                [disabled]="isMarkingUnread"
                (click)="markUnread()">
          <i class="fa fa-envelope-open" *ngIf="isMarkingUnread"></i>
          <i class="fa fa-envelope" *ngIf="!isMarkingUnread"></i>
        </button>
      </ng-container>

      <!-- Attachments toggle — only shown when the message actually has attachments -->
      <!--      <button tooltip="View attachments" type="button" class="btn btn-default btn-outline btn-sm mr"-->
      <!--              *ngIf="isInbound && message.has_attachments"-->
      <!--              (click)="showAttachments = !showAttachments"-->
      <!--              [class.active]="showAttachments">-->
      <!--        <i class="fa fa-paperclip"></i>-->
      <!--      </button>-->
      <button tooltip="Delete" type="button" class="btn btn-danger btn-outline btn-sm"
              (click)="confirmDelete()" [disabled]="isDeleting">
        <i class="fa fa-trash" *ngIf="!isDeleting"></i>
        <i class="fa fa-spinner fa-spin mr-sm" *ngIf="isDeleting"></i>

      </button>
    </div>
  </div>

  <!-- Patient link bar (inbox/sent — drafts manage their patient in compose) -->
  <div class="updox-detail-patient-bar" *ngIf="!isDraft"
       [class.updox-detail-patient-bar-linked]="message.patient_id">

    <!-- Linked -->
    <ng-container *ngIf="message.patient_id">
      <span class="updox-avatar updox-avatar-xs">{{ patientDisplayName.charAt(0).toUpperCase() }}</span>
      <div class="updox-detail-patient-info">
        <span class="fw-500 fs13">{{ patientDisplayName }}</span>
        <span class="text-muted fs12 ml-sm" *ngIf="patientDemographics(linkedPatientDetail) as demo">· {{ demo }}</span>
        <span class="text-secondary fw-500 fs11 ml-sm">— linked patient</span>
      </div>
    </ng-container>

    <!-- Not linked, search closed -->
    <ng-container *ngIf="!message.patient_id && !showLinkSearch">
      <i class="fa fa-user-o text-danger fs13"></i>
      <span class="text-danger fs12 updox-detail-patient-info">No patient linked to this message</span>
      <a class="btn btn-xs btn-secondary btn-outline" (click)="openLinkSearch()">
        <i class="fa fa-link mr-sm"></i>Link Patient
      </a>
    </ng-container>

    <!-- Search open (both link and change flows) -->
    <div class="updox-detail-patient-search" *ngIf="showLinkSearch">
      <div class="updox-patient-search-wrap">
        <div class="updox-patient-search-field">
          <i class="fa fa-search updox-patient-search-icon text-muted"></i>
          <input type="text" class="form-control input-sm updox-patient-search-input"
                 [value]="linkPatientQuery"
                 (input)="onLinkQueryChange($any($event.target).value)"
                 (blur)="closeLinkDropdownDelayed()"
                 placeholder="Search patient by name, phone or email…"
                 autocomplete="off" />
          <i class="fa fa-spinner fa-spin updox-patient-search-spinner text-muted"
             *ngIf="linkSearchLoading || isLinking"></i>
        </div>
        <div class="updox-patient-dropdown" *ngIf="showLinkDropdown">
          <div class="updox-patient-option" *ngFor="let p of linkPatientResults"
               (mousedown)="selectLinkPatient(p)">
            <span class="updox-avatar updox-avatar-xs">{{ patientInitialFor(p) }}</span>
            <div class="updox-patient-option-info">
              <div class="fw-500 fs13">{{ p.name }}</div>
              <div class="updox-patient-option-meta" *ngIf="patientDemographics(p) as demo">
                <i class="fa fa-id-card-o mr-sm text-muted"></i>{{ demo }}
              </div>
            </div>
          </div>
        </div>
        <p class="help-block text-muted fs11 m0 p-sm"
           *ngIf="linkPatientQuery && !linkSearchLoading && linkPatientResults.length === 0 && !showLinkDropdown">
          <i class="fa fa-exclamation-circle text-danger mr-sm"></i>No patients found
        </p>
      </div>
      <a class="btn btn-xs btn-default ml-sm" (click)="cancelLinkSearch()">Cancel</a>
    </div>
  </div>

  <!-- Reply chain banner — outbound reply we sent -->
  <div class="updox-reply-banner updox-reply-banner-sent" *ngIf="message.reply_to_message_id && !isInbound">
    <i class="fa fa-reply mr-xs"></i>
    This is a reply you sent to an earlier message.
  </div>

  <!-- Reply chain banner — inbound reply received from the other party -->
  <div class="updox-reply-banner updox-reply-banner-received" *ngIf="isInbound && message.subject?.startsWith('Re:')">
    <i class="fa fa-reply mr-xs"></i>
    This is a reply from <strong>{{ message.from_address }}</strong> to one of your messages.
  </div>

  <!-- Added-to-chart badge -->
  <div class="updox-chart-badge-bar" *ngIf="message.added_to_medical_chart">
    <span class="updox-chart-badge">
      <i class="fa fa-check-circle mr-xs"></i>Added to Medical Chart
    </span>
  </div>

  <!-- Inline delete confirm -->
  <div class="alert alert-danger p-sm m-sm" *ngIf="showDeleteConfirm">
    {{ deleteConfirmText }}
    <div class="pull-right">
      <a class="btn btn-xs btn-danger mr-sm" (click)="deleteMessage()">Yes, Delete</a>
      <a class="btn btn-xs btn-default" (click)="cancelDelete()">Cancel</a>
    </div>
  </div>

  <!-- Meta -->
  <div class="updox-detail-meta">
    <div class="media">
      <div class="media-left">
        <span class="updox-avatar updox-avatar-lg bg-secondary">
          {{ isDraft ? (message.to_address?.charAt(0)?.toUpperCase() || '?') : message.sender_initial }}
        </span>
      </div>
      <div class="media-body">
        <ng-container *ngIf="isDraft">
          <div class="fw-500">{{ message.to_address }}</div>
          <div class="text-muted fs13">To: {{ message.to_address }}</div>
          <div class="text-muted fs13">{{ message.updated_at | date:'MMM d, y · HH:mm' }}</div>
        </ng-container>
        <ng-container *ngIf="!isDraft">
          <div class="fw-500">{{ message.display_sender }}</div>
          <div class="text-muted fs13">To: {{ message.to_address }}</div>
          <div class="text-muted fs13">{{ message.created_at | date:'MMM d, y · HH:mm' }}</div>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="m0">


  <!-- Attachment panel -->
  <div class="updox-attachments-section-header" *ngIf="message.has_attachments" >
      <i class="fa fa-paperclip mr-sm"> </i>This message has attachments
  </div>
  <div class="updox-attachments-section" >
    <app-updox-attachments [message]="message" [readOnly]="!isInbound"></app-updox-attachments>
  </div>

  <hr class="m0">
  <!-- Message body — loaded on demand via get :direct_message to keep the list payload light -->
  <div class="updox-detail-body">
    <div *ngIf="isLoadingBody" class="text-center p-md text-muted">
      <i class="fa fa-spinner fa-spin mr-sm"></i>Loading...
    </div>
    <ng-container *ngIf="!isLoadingBody">
      <div *ngIf="fullMessage?.body_html" [innerHTML]="fullMessage.body_html | safeHtml"></div>
      <pre *ngIf="!fullMessage?.body_html && fullMessage?.body_text" class="updox-body-text">{{ fullMessage.body_text }}</pre>
      <p *ngIf="!fullMessage?.body_html && !fullMessage?.body_text" class="text-muted">(No content)</p>
    </ng-container>
  </div>


</ng-container>

<!-- Empty state -->
<div *ngIf="!message" class="updox-detail-empty">
  <i class="fa fa-envelope-o fs40 d-block mb"></i>
  <p class="m0">Select a message to read</p>
</div>
